/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-11-27 09:32:42
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-02-21 11:10:48
 * @FilePath: \vue-hepha-order\src\views\dealer\queryConfig\DealerListQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const DealerListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'customer.customerName', // 公司名称
            key:'company_name',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.companyName',
        },
        {
            // name:'customer.customerType', // 联系人
            key:'contact_person',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.contactPerson',
        },
        {
            // name:'customer.customerEmail', // 邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.email',
        },
        {
            // name:'customer.customerCountry', // 国家
            key:'country',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.country',
            options:[]
        },
        // {
        //     // name:'customer.customerCity', // 城市
        //     key:'city',
        //     type:'input',   
        //     allowClear:true,
        //     width:'180px',
        //     placeholder:'dealer.city',
        // },
        {
            // name:'customer.erpCode', // ERP code
            key:'erp_code',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.erpCode',
        },
        {
            // name:'customer.customerCountry', // 是否激活
            key:'active_flag',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.isActive2',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'base.NO',
                },
                {
                    value:1,
                    label:'base.YES',
                }
            ]
        },
        {
            // name:'customer.customerCountry', // 服务中心
            key:'service_flag',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.serviceCenter2',
            optionToLocale:true,
            options:[
                {
                    value:'NO',
                    label:'base.NO',
                },
                {
                    value:'YES',
                    label:'base.YES',
                }
            ]
        },
        {
            // name:'customer.customerCountry', // 测试中心
            key:'test_flag',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.testCenter2',
            optionToLocale:true,
            options:[
                {
                    value:'NO',
                    label:'base.NO',
                },
                {
                    value:'YES',
                    label:'base.YES',
                }
            ]
        },
        {
            // name:'customer.customerCountry', // 销售经理
            key:'sale_manager',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.saleManager2',
            optionToLocale:true,
            options:[]
        },
        {
            key:'contract_signed',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.contractSigned',
            optionToLocale:true,
            options:[
                {
                    value:'NO',
                    label:'base.NO',
                },
                {
                    value:'YES',
                    label:'base.YES',
                }
            ]
        },
        {
            key:'c2c_flag',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealer.c2cFlag',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'base.NO',
                },
                {
                    value:1,
                    label:'base.YES',
                }
            ]
        },
    ]
}

// 公司信息
const CompanyForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            name:'dealer.city', // 城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.street', // 街道
            key:'street',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.houseNumber', // 门牌号
            key:'house_number',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.phone', // 手机
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.mobile', // 电话
            key:'mobile',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.website', // 网址
            key:'website',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'config.vatNo', // 税号
            key:'vat_no',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
    ]
}

// 店铺信息
const StoreForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            name:'dealer.storeCity', // 城市
            key:'store_city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.storeAddress', // 地址
            key:'store_address',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.storeHouseNumber', // 门牌号
            key:'store_house_number',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.storeZip', // 邮编
            key:'store_zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.storePhone', // 手机
            key:'store_phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.storeEmail', // 店铺邮箱
            key:'store_email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
    ]
}

// 发货信息
const DeliveryForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            name:'dealer.deliveryCity', // 城市
            key:'delivery_city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.deliveryAddress', // 地址
            key:'delivery_address',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.deliveryHouseNumber', // 门牌号
            key:'delivery_house_number',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.deliveryZip', // 邮编
            key:'delivery_zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.deliveryPhone', // 手机
            key:'delivery_phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
        {
            name:'dealer.deliveryEmail', // 发货邮箱
            key:'delivery_email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'370px',
        },
    ]
}

// 其他信息
const OtherForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            name:'dealer.salesAreaApprox', // 销售面积
            key:'sales_area_approx',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.branches', // 分支
            key:'branches',
            type:'radio',   
            allowClear:true,
            required:true,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.no',
                },
                {
                    value:'YES',
                    label:'base.yes',
                }
            ]
        },
        {
            name:'dealer.branchesReamrk', // 分支备注
            key:'branches_remark',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.serviceWorkshop', // 是否服务车间
            key:'service_workshop',
            type:'radio',   
            allowClear:true,
            required:true,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.no',
                },
                {
                    value:'YES',
                    label:'base.yes',
                }
            ]
        },
        {
            name:'dealer.foundation', // 成立年份
            key:'foundation',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.portfolio', // 投资TOP品牌
            key:'portfolio',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
    ]
}

// 其他信息
const OtherSettingForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            name:'dealer.saleManager', // 销售管理
            key:'sale_manager',
            type:'select',   
            allowClear:true,
            width:'370px',
            options:[],
        },
        {
            name:'dealer.isActive', // 是否活跃
            key:'active_flag',
            type:'radio',   
            allowClear:true,
            width:'370px',
            radioData:[
                {
                    value:0,
                    label:'base.NO',
                },
                {
                    value:1,
                    label:'base.YES',
                }
            ]
        },
        {
            name:'dealer.testCenter', // 测试中心
            key:'test_flag',
            type:'radio',   
            allowClear:true,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.NO',
                },
                {
                    value:'YES',
                    label:'base.YES',
                }
            ]
        },
        {
            name:'dealer.serviceCenter', // 服务中心
            key:'service_flag',
            type:'radio',   
            allowClear:true,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.NO',
                },
                {
                    value:'YES',
                    label:'base.YES',
                }
            ]
        },
        {
            name:'dealer.bico',// bico
            key:'bico',
            type:'radio',   
            allowClear:true,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.NO',
                },
                {
                    value:'YES',
                    label:'base.YES',
                }
            ]
        },
        {
            name:'dealer.salesNote', // 销售备注
            key:'sales_note',
            type:'textarea',   
            allowClear:true,
            show:false,
            width:'370px',
        },
        {
            name:'dealer.customerClassification', // 客户分类
            key:'classification',
            type:'select',   
            allowClear:true,
            width:'370px',
            options:[
                {
                    value:1,
                    label:'A (200)',
                },
                {
                    value:2,
                    label:'B (100)',
                },
                {
                    value:3,
                    label:'C (<100)',
                },
                {
                    value:4,
                    label:'D (Service)',
                }
            ]
        },
        {
            name:'dealer.commitment', // 承诺
            key:'commitment',
            type:'select',   
            allowClear:true,
            optionToLocale:true,
            width:'370px',
            options:[
                {
                    value:'Low',
                    label:'dealer.low',
                },
                {
                    value:'Mid',
                    label:'dealer.middle',
                },
                {
                    value:'High',
                    label:'dealer.high',
                },
            ]
        },
        {
            name:'dealer.potential', // 潜力
            key:'potential',
            type:'select',   
            allowClear:true,
            optionToLocale:true,
            width:'370px',
            options:[
                {
                    value:'Low',
                    label:'dealer.low',
                },
                {
                    value:'Mid',
                    label:'dealer.middle',
                },
                {
                    value:'High',
                    label:'dealer.high',
                },
            ]
        },
        {
            name:'dealer.financialInformation', // 财务信息
            key:'financial_information',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        // {
        //     name:'dealer.year', // 预测年份
        //     key:'year',
        //     type:'yearDate',   
        //     allowClear:true,
        //     width:'370px',
        // },
        {
            name:'', // 预计销量
            key:'estimate',
            type:'inputNumber',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'config.vatNo', // 税号
            key:'vat_no',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
        {
            name:'dealer.contractSigned', // 是否签署合同
            key:'contract_signed',
            type:'radio',   
            allowClear:true,
            required:false,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.no',
                },
                {
                    value:'YES',
                    label:'base.yes',
                }
            ]
        },
        {
            name:'dealer.salesAreaApprox', // 销售面积
            key:'sales_area_approx',
            type:'input',   
            allowClear:true,
            suffix:true,
            suffixText:'m²',
            width:'370px',
        },
        {
            name:'dealer.branches', // 分支
            key:'branches',
            type:'radio',   
            allowClear:true,
            required:true,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.no',
                },
                {
                    value:'YES',
                    label:'base.yes',
                }
            ]
        },
        {
            name:'dealer.branchesReamrk', // 分支备注
            key:'branches_remark',
            type:'input',   
            allowClear:true,
            disabled:true,
            width:'370px',
        },
        {
            name:'dealer.serviceWorkshop', // 是否服务车间
            key:'service_workshop',
            type:'radio',   
            allowClear:true,
            required:true,
            width:'370px',
            radioData:[
                {
                    value:'NO',
                    label:'base.no',
                },
                {
                    value:'YES',
                    label:'base.yes',
                }
            ]
        },
        {
            name:'dealer.portfolio', // 投资TOP品牌
            key:'portfolio',
            type:'input',   
            allowClear:true,
            width:'370px',
        },
    ]
}

DealerListQuery.formField.forEach(item=>{
    DealerListQuery.formData[item.key] = ''
})

CompanyForm.formField.forEach(item=>{
    CompanyForm.formData[item.key] = ''
})

StoreForm.formField.forEach(item=>{
    StoreForm.formData[item.key] = ''
})

DeliveryForm.formField.forEach(item=>{
    DeliveryForm.formData[item.key] = ''
})

OtherForm.formField.forEach(item=>{
    OtherForm.formData[item.key] = ''
})

OtherSettingForm.formField.forEach(item=>{
    OtherSettingForm.formData[item.key] = ''
})

export {
    DealerListQuery,
    CompanyForm,
    StoreForm,
    DeliveryForm,
    OtherForm,
    OtherSettingForm,
}